import { NewQueryResponse } from '~types';

export function getNextPage<T>(
  _lastPages: NewQueryResponse<T>,
  allPages: NewQueryResponse<T>[],
  ROW_PER_PAGE: number,
) {
  const totalCount = _lastPages.count;
  const currentPage = allPages.length - 1;
  const totalPages = Math.ceil(totalCount / ROW_PER_PAGE);

  return currentPage < totalPages - 1 ? currentPage + 1 : undefined;
}
